import React from 'react';
import './LoadingAnimation.css'; // CSS 파일 불러오기

const LoadingAnimation = () => {
    return (
        <div className="loading-animation">
            <div className="wrapper">
                <div className="ball"></div>
                <div className="ball"></div>
                <div className="ball"></div>
            </div>
            <svg>
                <defs>
                    <filter id="filter">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="18" result="blur" />
                        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 28 -10" result="filter" />
                        <feComposite in="SourceGraphic" in2="filter" operator="atop" />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};

export default LoadingAnimation;